import { BaseConnection, NclMessageType, ReceiveData } from "../common/communication";
import { CSClientFile, DeviceConnectorDataRequest, TDeviceConnectResult } from "../common/communication.base";

export default class DeviceConnector {
  private files: Map<string, string>;
  private connectionString: string;
  private connection: BaseConnection;

  public constructor() {
    this.files = new Map<string, string>();
  }

  public setFile(data: CSClientFile) {
    if (data) {
      this.files.set(data.FileName, data.Url);
    }
  }

  public connect(connectionString: string): Promise<DeviceConnectorDataRequest> {
    this.connectionString = connectionString;
    return new Promise((resolve, reject) => {
      this.getConnection()
        .connect()
        .then((res) => {
          resolve({ ResultType: TDeviceConnectResult.dcrOK, ResultMessage: undefined } as DeviceConnectorDataRequest);
        })
        .catch((reason) => {
          reject(`Failed to connect to device connector at ${connectionString}`);
        });
    });
  }

  public disconnect(): Promise<DeviceConnectorDataRequest> {
    if (this.getConnection().isConnected) {
      return new Promise<DeviceConnectorDataRequest>((resolve, reject) => {
        this.getConnection()
          .disconnect()
          .then((val) => {
            resolve({ ResultType: TDeviceConnectResult.dcrOK, ResultMessage: undefined } as DeviceConnectorDataRequest);
          })
          .catch((reason) => {
            reject({ ResultType: TDeviceConnectResult.dcrError, ResultMessage: reason } as DeviceConnectorDataRequest);
          });
      });
    }

    return Promise.reject<DeviceConnectorDataRequest>({
      ResultType: TDeviceConnectResult.dcrError,
      ResultMessage: "Connection was not connected",
    } as DeviceConnectorDataRequest);
  }

  public get isConnected(): boolean {
    return this.connectionString && this.getConnection().isConnected;
  }

  private getConnection(): BaseConnection {
    if (this.connection == null) {
      this.connection = new BaseConnection(this.connectionString, false);
    }

    return this.connection;
  }

  public sendRequest(request: string): Promise<DeviceConnectorDataRequest> {
    let rq = request;
    if (this.isConnected) {
      if (this.files.size > 0) {
        rq = this.replaceFile(JSON.parse(rq));
      }
      if (this.connection.sendText(rq)) {
        return new Promise<DeviceConnectorDataRequest>((resolve, reject) => {
          this.connection
            .receive()
            .then((result: ReceiveData) => {
              if (result && result.message && result.message.messageType == NclMessageType.nmsgOK && result.message.hasOwnProperty("msgType")) {
                let o: any = result.message;
                let msgType = o.msgType;
                if (msgType !== undefined) {
                  resolve({
                    ResultType: msgType,
                    ResultMessage: result.message.json && result.message.json.length > 0 ? result.message.json : undefined,
                  } as DeviceConnectorDataRequest);
                  return;
                }
              }
              reject({ ResultType: TDeviceConnectResult.dcrError, ResultMessage: `Invalid message type: ${result}` } as DeviceConnectorDataRequest);
            })
            .catch((reason) => {
              reject(reason);
            });
        });
      } else {
        return Promise.reject<DeviceConnectorDataRequest>({
          ResultType: TDeviceConnectResult.dcrError,
          ResultMessage: "Message couldn't be sended.",
        } as DeviceConnectorDataRequest);
      }
    }
    return Promise.reject<DeviceConnectorDataRequest>({
      ResultType: TDeviceConnectResult.dcrError,
      ResultMessage: "Connection was not connected",
    } as DeviceConnectorDataRequest);
  }

  private replaceFile(message: any): any {
    if (message && message.Json) {
      this.files.forEach((url: string, key: string) => {
        if (message.Json.indexOf(key) >= 0) {
          message.Json = message.Json.replace(key, url);
        }
      });
    }
    this.files.clear();

    return JSON.stringify(message);
  }
}
